import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, ChevronRight } from 'lucide-react';
import { salesApi } from '../api';

const fmtIST = (v) => {
  const d = new Date(/Z|[+-]\d\d:\d\d$/.test(v) ? v : `${v}Z`);
  return d.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata', day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) + ' IST';
};

export default function SyncFailedBanner() {
  const [status, setStatus] = useState(null);
  useEffect(() => { salesApi.syncStatus().then(setStatus).catch(() => {}); }, []);
  if (!status?.alertActive) return null;
  const { latest, lastSuccess } = status;
  return (
    <div data-testid="sync-failed-banner" role="alert" className="mb-6 flex flex-wrap items-center gap-3 rounded-lg border border-[#E9B8B0] bg-[#FBE7E4] px-4 py-3 text-[#9b2c1f]">
      <AlertTriangle size={18} className="shrink-0" />
      <div className="flex-1 min-w-[240px] text-[13px]">
        <div className="font-semibold">Sales data sync failed · {fmtIST(latest.startedAt)}</div>
        <div className="text-[12.5px] opacity-90 break-words" data-testid="sync-failed-reason">
          {latest.errorSummary || 'See Import runs for details.'}
          {lastSuccess ? ` · Last successful sync: ${fmtIST(lastSuccess.startedAt)}` : ' · No successful sync yet'}
        </div>
      </div>
      <Link to="/app/settings?tab=import-runs" data-testid="sync-failed-banner-link" className="inline-flex items-center gap-1 px-3 py-1.5 rounded-md bg-[#9b2c1f] text-white text-[12.5px] font-medium hover:bg-[#7f2418]">
        View import runs <ChevronRight size={14} />
      </Link>
    </div>
  );
}
